<template>
  <v-dialog :value="show" persistent max-width="650">
    <v-card class="delete-dialog">
      <v-card-title class="main-subtitle dark--text fs-20">Create New Profile</v-card-title>
      <v-card-text class="pb-0 pt-4">
        <v-form v-model="valid" ref="form">
          <p class="input-label text-style dark--text mb-0">Choose Profile Target</p>
          <v-row>
            <v-col md="6" sm="12">
              <v-select
                v-model="type"
                :items="types"
                solo
                item-text="text"
                item-value="value"
                :menu-props="{ offsetY: true }"
                class="select-field"
                hide-details
                :rules="[rules.required]"
              />
            </v-col>
            <v-col md="6" sm="12">
              <v-select
                v-model="secondType"
                :items="secondTypes"
                solo
                :menu-props="{ offsetY: true }"
                class="select-field"
                hide-details
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <my-network-documents
            v-if="type === 'my network' && secondType === 'documents'"
            :collector.sync="collector"
            :collectors="collectors"
            :loadingCollectors="loadingCollectors"
            :isClearable="true"
          />
          <my-network-database
            v-else-if="type === 'my network' && secondType === 'database'"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="cancel-btn" text @click="handleClose">Cancel</v-btn>
        <v-btn class="save-btn" type="submit" text @click="handleConfirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { MY_NETWORK_TYPES, MY_CLOUD_SERVICES_TYPES, TYPES } from '../../Scheduling/data'

export default {
  name: 'LaunchDialog',
  components: {
    'my-network-documents': () => import('../../Scheduling/MyNetworkDocuments'),
    'my-network-database': () => import('../../Scheduling/MyNetworkDatabase')
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    activeCollector: {
      type: String,
      default: null
    }
  },
  data: vm => {
    return {
      valid: true,
      collector: '',
      day: '',
      scanTypes: [
        { name: 'Discovery', value: 'discovery' },
        { name: 'Risk', value: 'deep' }
      ],
      rules: {
        required: v => !!v || 'Field is Required'
      },
      type: 'my network',
      secondType: null
    }
  },
  computed: {
    ...mapGetters(['currentOrganization', 'collectors', 'loadingCollectors']),
    times () {
      const res = []
      for (let i = 1; i <= 12; i++) {
        res.push(i)
      }
      return res
    },
    types () {
      return TYPES
    },
    secondTypes () {
      let arr = []
      if (this.type === 'my network') {
        arr = MY_NETWORK_TYPES
      } else if (this.type === 'my_cloud_service') {
        arr = MY_CLOUD_SERVICES_TYPES
      }
      return arr
    }
  },
  methods: {
    handleConfirm () {
      this.$refs.form.validate()
      if (!this.valid) return
      const data = {
        type_of_scan: this.type,
        scan_area: this.secondType,
        collector_id: this.collector,
        organization_id: this.currentOrganization.entity_id,
        scan_time: '1 PM',
        drives: this.path,
        run_now: true,
        scan_command_type: this.scanTypes[1].value
      }
      this.$mixpanel.track('Discovery Scan Created')
      this.$store.dispatch('schedulingServices/addScan', data)
      this.handleClose()
    },
    handleClose () {
      this.$emit('onClose')
      this.$refs.form.reset()
      this.$nextTick(() => {
        this.type = 'my network'
      })
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    }
  },
  watch: {
    show (val) {
      if (!val) return
      this.type = 'my network'
      this.secondType = 'documents'
      this.collector = this.activeCollector
    }
  }
}
</script>

<style lang="scss">
  .v-input--checkbox {
    .v-icon {
      color: #999;
      transition: 0.3s;
    }
    .v-label {
      color: #000;
    }
  }
</style>
